<svg>
  <use attr.xlink:href="{{ this.svgSpriteUrl }}#{{ type }}"></use>
</svg>
